export default __webpack_public_path__ + "static/media/bridgeConstruction.07b7c0e5.jpg";